module.exports = __webpack_public_path__ + "media/images/sec4bg-eeeeb4defe6e7298d8ed392c940c4377.svg";